import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Text from '@ilg-totallymoney/ui/components/Text'

import { MockQueryUnion } from '@api/mocks/get-scored-categories'

const getTestAccountName = (query?: MockQueryUnion) => {
    if (query === 'mock-scored') {
        return 'Scored Customer'
    }

    if (query === 'mock-altproducts') {
        return 'Alt Product Customer'
    }

    if (query === 'mock-bt-downsell') {
        return 'Downsell Customer'
    }
}

const DevToolBannerInfo = ({
    queryScoreId,
}: {
    queryScoreId?: MockQueryUnion
}) => {
    return (
        <Flex
            backgroundColor="alertInfo100"
            width="100%"
            height="50px"
            justifyContent="center"
        >
            <Flex justifyContent="center" alignItems="center">
                <Text weight="bold">
                    <strong>Info:</strong> {getTestAccountName(queryScoreId)}
                </Text>
            </Flex>
        </Flex>
    )
}

export default DevToolBannerInfo
